/**
 * A layout for one column of content.
 *
 * To keep content from getting too wide and being uncomfortable to read, this
 * layout will set the content on 12-column layouts at either 7 or 8 columns
 * depending on whether this component has an even or odd number of columns to
 * work with.
 *
 * If the grid is below 7 columns wide on a 12-column layout, the content will
 * take up the full component width.
 *
 * The content always takes up the full width on layouts smaller than 12
 * columns.
 */
import React from 'react';
import {CssGrid, CssGridRow, CssGridColumn, CssGridSpace} from '../layouts/CssGrid';
import CoreMetrics from '../core/Metrics';


const getWindowColumnCount = (screenName) => {
    return parseInt(CoreMetrics.Grid.ColumnCount()[screenName], 10);
};

// We're fine with 7 or 8 columns on 12-column layouts. We want the
// space around the content to be symmetrical, so we'll use 7 if the
// number of columns we have is odd and 8 if it's even.
const getContentWidth = (numColumns) => {
    if (numColumns <= 7) {
        return numColumns;
    } else if (numColumns % 2 === 0) {
        return 8;
    } else {
        return 7;
    }
};


export default class OneContentColumnLayout extends React.Component {
    render() {
        const {column1, size, sizePhone, sizeTablet, sizeDesktop} = this.props;

        const gridWidthPhone = sizePhone ||
            size ||
            getWindowColumnCount("Phone");
        const gridWidthTablet = sizeTablet ||
            size ||
            getWindowColumnCount("Tablet");
        const gridWidthDesktop = sizeDesktop ||
            size ||
            getWindowColumnCount("Desktop");

        const contentWidthTablet = getContentWidth(gridWidthTablet);
        const contentWidthDesktop = getContentWidth(gridWidthDesktop);

        const sideSpace = <CssGridSpace
            sizePhone={0}
            sizeTablet={(gridWidthTablet - contentWidthTablet) / 2}
            sizeDesktop={(gridWidthDesktop - contentWidthDesktop) / 2}
        />

        return <CssGrid>
            <CssGridRow>
                {sideSpace}

                <CssGridColumn
                    sizePhone={gridWidthPhone}
                    sizeTablet={contentWidthTablet}
                    sizeDesktop={contentWidthDesktop}
                >
                    {column1}
                </CssGridColumn>

                {sideSpace}
            </CssGridRow>
        </CssGrid>;
    }
}



// WEBPACK FOOTER //
// ./src/layouts/OneContentColumnLayout.jsx